import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  DataGrid,
  GridToolbarQuickFilter,
  GridLinkOperator,
  gridClasses,
} from "@mui/x-data-grid";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import FormControl from "@mui/material/FormControl";
import GridItemLogin from "components/Grid/GridItemLogin.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeadertab.js";
import CloseIcon from "@mui/icons-material/Close";
import CardBody from "components/Card/CardBody.js";
import Themphuluc9 from "components/Phuluc9/Themphuluc9.js";
import Capnhatphuluc9 from "components/Phuluc9/Capnhatphuluc9.js";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import Config from "conFig.js";
import dayjs from "dayjs";
import styles from "assets/jss/material-dashboard-react/components/tableviewStyle.js";
import { read, utils } from "xlsx";
const useStyles = makeStyles(styles);
const datagridSx = {
  [`& .${gridClasses.cell}`]: {
    py: 1,
  },
  [`& .center`]: {
    justifyContent: "center !important",
  },
  borderRadius: 2,
  "& .MuiDataGrid-main": { borderRadius: 2 },
  "& .MuiDataGrid-virtualScrollerRenderZone": {
    "& .MuiDataGrid-row": {
      "&:nth-of-type(2n)": { backgroundColor: "rgba(235, 235, 235, .7)" },
    },
  },
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "rgba(0,0,255,0.6)",
    color: "rgb(255 255 255)",
    fontSize: 16,
  },
  "& .MuiInputBase-root": {
    height: "25px",
  },
};
const txcolumn = [
  {
    field: "stt",
    headerName: "STT",
    width: 120,
    headerAlign: "center",
  },
  {
    field: "ten",
    headerName: "Tên đơn vị",
    width: 250,
    headerAlign: "center",
  },
  {
    field: "sogiaycndkkd",
    headerName: "Số giấy CNĐKKD",
    width: 170,
    headerAlign: "center",
  },
  {
    field: "diachi",
    headerName: "Địa chỉ",
    width: 230,
    headerAlign: "center",
  },
  {
    field: "dienthoai",
    headerName: "Số điện thoại",
    width: 150,
    headerAlign: "center",
  },
  {
    field: "ngay_giaithe",
    headerName: "Ngày giải thể",
    width: 180,
    headerAlign: "center",
    valueFormatter: (params) =>
      params.value !== "N/A" ? dayjs(params.value).format("DD/MM/YYYY") : "",
  },
  {
    field: "ngay_ngunghoatdong",
    headerName: "Ngày ngưng hoạt động",
    width: 200,
    headerAlign: "center",
    valueFormatter: (params) =>
      params.value !== "N/A" ? dayjs(params.value).format("DD/MM/YYYY") : "",
  },
  {
    field: "ngay_thuhoi_giaycndkkd",
    headerName: "Ngày thu hồi CNĐKKD",
    width: 200,
    headerAlign: "center",
    valueFormatter: (params) =>
      params.value !== "N/A" ? dayjs(params.value).format("DD/MM/YYYY") : "",
  },
  {
    field: "ghichu",
    headerName: "Ghi chú",
    width: 200,
    headerAlign: "center",
  },
];

export default function Phuluc9() {
  const classes = useStyles();
  const [pageSize, setPageSize] = React.useState(50);
  const [baocao_id, setBaocao_id] = React.useState(0);
  const [openthem, setOpenthem] = React.useState(false);
  const [thangnam, setThangnam] = React.useState(dayjs());
  const [dataimport, setDataimport] = React.useState([]);
  const hiddenFileInput = React.useRef(null);
  const [disableBT, setDisableBT] = React.useState(true);
  const [baocao, setBaocao] = React.useState([]);
  const [opensua, setOpensua] = React.useState(false);
  const [openxoa, setOpenxoa] = React.useState(false);
  const [alert, setAlert] = React.useState(false);
  const [alert1, setAlert1] = React.useState(false);
  const handleClose = () => {
    setOpenthem(false);
    getbaocao();
  };
  const handleClosesua = () => {
    setOpensua(false);
    getbaocao();
  };
  const openthembc = () => {
    setOpenthem(true);
    setDisableBT(true); // fix delete button
  };
  const handleClosexoa = () => {
    setOpenxoa(false);
    getbaocao();
  };
  const quickSearchToolbar = () => {
    return (
      <Box
        sx={{
          p: 0.5,
          pb: 0,
        }}
      >
        <GridToolbarQuickFilter
          quickFilterParser={(searchInput: string) =>
            searchInput
              .split(",")
              .map((value) => value.trim())
              .filter((value) => value !== "")
          }
          placeholder="Tìm kiếm"
        />
      </Box>
    );
  };
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getbaocao = () => {
    setDisableBT(true); // fix delete button
    var thang = String(thangnam.$M + 1).padStart(2, "0") + "/" + thangnam.$y;
    var url =
      Config.backend +
      "/api/BaoCao/getslpl09thang?thang=" +
      thang +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setBaocao(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const xoabaocao = () => {
    var url = Config.backend + "/api/BaoCao/xoaslpl09id";
    fetch(url, {
      method: "DELETE",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        id: baocao_id,
        username: username,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data === "1") {
          showNotification();
          getbaocao();
          setDisableBT(true);
        }
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const xoadulieu = () => {
    var thang = String(thangnam.$M + 1).padStart(2, "0") + "/" + thangnam.$y;
    var url = Config.backend + "/api/BaoCao/xoaslpl09thang";
    fetch(url, {
      method: "DELETE",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        thang: thang,
        username: username,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data === "1") {
          console.log("");
        }
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
    truocimport();
  };
  const insertbaocao = (
    sogiaycndkkd,
    ten,
    diachi,
    dienthoai,
    ngaygt,
    ngaynhd,
    ngayth,
    ghichu
  ) => {
    var thang = String(thangnam.$M + 1).padStart(2, "0") + "/" + thangnam.$y;
    var url = Config.backend + "/api/BaoCao/themslpl09";
    fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        thang: thang,
        sogiaycndkkd: sogiaycndkkd,
        ten: ten,
        diachi: diachi,
        dienthoai: dienthoai,
        ngay_giaithe: ngaygt,
        ngay_ngunghoatdong: ngaynhd,
        ngay_thuhoi_giaycndkkd: ngayth,
        ghichu: ghichu,
        username: username,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data === "1") {
          console.log("");
        }
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const truocimport = () => {
    dataimport.map((item) => {
      if (Object.values(item)[0] > 0) {
        insertbaocao(
          Object.values(item)[1],
          Object.values(item)[2],
          Object.values(item)[3],
          Object.values(item)[4],
          convertdate(Object.values(item)[5]),
          convertdate(Object.values(item)[6]),
          convertdate(Object.values(item)[7]),
          Object.values(item)[8]
        );
      }
    });
    showNotification1();
  };
  const handleClick = () => {
    hiddenFileInput.current.click();
  };

  const uploadFiles = (event) => {
    if (event.target.files.length) {
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.onload = (event) => {
        const wb = read(event.target.result);
        const sheets = wb.SheetNames;
        if (sheets.length) {
          const rows = utils.sheet_to_json(wb.Sheets[sheets[0]]);
          if (rows.length) {
            setDataimport(rows);
          }
        }
      };
      reader.readAsArrayBuffer(file);
      setOpenxoa(true);
    }
  };
  const convertdate = (serial) => {
    if (serial) {
      var utc_days = Math.floor(serial - 25569);
      var utc_value = utc_days * 86400;
      var date_info = new Date(utc_value * 1000);
      return (
        date_info.getFullYear() +
        "-" +
        (date_info.getMonth() + 1) +
        "-" +
        date_info.getDate()
      );
    } else {
      return "";
    }
  };
  const getfile = () => {
    window.location.href = Config.link + "1c4054f0-12e8-4278-a682-fa7163d524ca";
  };
  const showNotification = () => {
    setAlert(true);
    setTimeout(function () {
      setAlert(false);
    }, 2000);
  };
  const showNotification1 = () => {
    setAlert1(true);
    setTimeout(function () {
      setAlert1(false);
    }, 2000);
  };
  React.useEffect(() => {
    getbaocao();
  }, []);
  return (
    <GridContainer>
      <GridItem xs={12} sm={10} md={12} style={{ marginTop: 5 }}>
        <FormControl style={{ width: "15%" }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Chọn năm"
              value={thangnam}
              format="MM/YYYY"
              onChange={(newValue) => {
                setThangnam(newValue);
                setBaocao([]);
              }}
              slotProps={{ textField: { size: "small" } }}
              views={["month", "year"]}
              sx={{
                "& .MuiInputBase-root": {
                  height: "27px",
                },
              }}
            />
          </LocalizationProvider>
        </FormControl>
        <FormControl style={{ width: "12%", marginLeft: 10 }}>
          <Button
            color="primary"
            variant="contained"
            style={{ height: 27 }}
            onClick={getbaocao}
          >
            Xem
          </Button>
        </FormControl>
        <FormControl style={{ width: "12%", marginLeft: 10 }}>
          <Button
            color="success"
            variant="contained"
            style={{ height: 27 }}
            onClick={openthembc}
          >
            Thêm mới
          </Button>
        </FormControl>
        <FormControl style={{ width: "8%", marginLeft: 10 }}>
          <Button
            color="error"
            variant="contained"
            style={{ height: 27 }}
            disabled={disableBT}
            onClick={xoabaocao}
          >
            Xóa
          </Button>
        </FormControl>
        <FormControl style={{ width: "15%", marginLeft: 10 }}>
          <Button
            color="warning"
            variant="contained"
            onClick={handleClick}
            style={{ height: "25px" }}
          >
            Import excel
          </Button>
          <input
            type="file"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            onChange={uploadFiles}
            ref={hiddenFileInput}
            style={{ display: "none" }}
          />
        </FormControl>
        <FormControl style={{ width: "15%", marginLeft: 10 }}>
          <Button
            color="warning"
            variant="contained"
            onClick={getfile}
            style={{ height: "25px" }}
          >
            Tải file mẫu
          </Button>
        </FormControl>
      </GridItem>
      <GridItem xs={12} sm={10} md={12}>
        <div style={{ height: 500, width: "100%", marginTop: "10px" }}>
          <DataGrid
            getRowId={(row) => row.id}
            rows={baocao}
            columns={txcolumn}
            checkboxSelection={false}
            getRowHeight={() => "auto"}
            headerHeight={35}
            onRowClick={(params) => {
              setDisableBT(false);
              setBaocao_id(Number(params.row.id));
            }}
            onCellDoubleClick={(params, event) => {
              if (!event.ctrlKey) {
                setOpensua(true);
                setDisableBT(true); // fix delete button
              }
            }}
            sx={datagridSx}
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[20, 50, 100]}
            pagination
            initialState={{
              filter: {
                filterModel: {
                  items: [],
                  quickFilterLogicOperator: GridLinkOperator.Or,
                },
              },
            }}
            components={{ Toolbar: quickSearchToolbar }}
          />
        </div>
      </GridItem>
      <GridItem xs={12} sm={10} md={12}>
        <Modal
          open={openthem}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div>
            <GridContainer>
              <GridItemLogin xs={12} sm={12} md={4}></GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={4}>
                <Card>
                  <CardHeader color="primary" style={{ height: 10 }}>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={10}>
                        <FormControl
                          style={{ width: "100%", marginTop: "10px" }}
                        >
                          <h6
                            className={classes.cardTitleWhite}
                            style={{ marginTop: "-5px" }}
                          >
                            Thêm báo cáo
                          </h6>
                        </FormControl>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={1}></GridItem>
                      <GridItem xs={12} sm={12} md={1}>
                        <FormControl
                          style={{ width: "100%", marginTop: "1px" }}
                        >
                          <CloseIcon onClick={handleClose} />
                        </FormControl>
                      </GridItem>
                    </GridContainer>
                  </CardHeader>
                  <Themphuluc9 />
                </Card>
              </GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={4}></GridItemLogin>
            </GridContainer>
          </div>
        </Modal>
      </GridItem>
      <GridItem xs={12} sm={10} md={12}>
        <Modal
          open={opensua}
          onClose={handleClosesua}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div>
            <GridContainer>
              <GridItemLogin xs={12} sm={12} md={4}></GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={4}>
                <Card>
                  <CardHeader color="primary" style={{ height: 10 }}>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={10}>
                        <FormControl
                          style={{ width: "100%", marginTop: "10px" }}
                        >
                          <h6
                            className={classes.cardTitleWhite}
                            style={{ marginTop: "-5px" }}
                          >
                            Cập nhật báo cáo
                          </h6>
                        </FormControl>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={1}></GridItem>
                      <GridItem xs={12} sm={12} md={1}>
                        <FormControl
                          style={{ width: "100%", marginTop: "1px" }}
                        >
                          <CloseIcon onClick={handleClosesua} />
                        </FormControl>
                      </GridItem>
                    </GridContainer>
                  </CardHeader>
                  <Capnhatphuluc9 baocao_id={baocao_id} />
                </Card>
              </GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={4}></GridItemLogin>
            </GridContainer>
          </div>
        </Modal>
      </GridItem>
      <GridItem xs={12} sm={10} md={12}>
        <Modal
          open={openxoa}
          onClose={handleClosexoa}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div>
            <GridContainer>
              <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={6}>
                <Card>
                  <CardHeader color="primary" style={{ height: 10 }}>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={8}>
                        <FormControl
                          style={{ width: "100%", marginTop: "10px" }}
                        >
                          <h6
                            className={classes.cardTitleWhite}
                            style={{ marginTop: "-5px" }}
                          >
                            Xác nhận xóa dữ liệu
                          </h6>
                        </FormControl>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={3}></GridItem>
                      <GridItem xs={12} sm={12} md={1}>
                        <FormControl
                          style={{ width: "100%", marginTop: "1px" }}
                        >
                          <CloseIcon onClick={handleClosexoa} />
                        </FormControl>
                      </GridItem>
                    </GridContainer>
                  </CardHeader>
                  <CardBody>
                    <GridItem xs={12} sm={12} md={12}>
                      <FormControl style={{ width: "100%", marginLeft: 10 }}>
                        Xác nhận sẽ xóa dữ liệu cũ nếu có và thêm dữ liệu mới
                      </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <FormControl
                        style={{ width: "30%", marginLeft: 10, marginTop: 10 }}
                      >
                        <Button
                          color="success"
                          variant="contained"
                          style={{ height: "25px" }}
                          onClick={xoadulieu}
                        >
                          Xác nhận
                        </Button>
                      </FormControl>
                      <FormControl
                        style={{ width: "10%", marginLeft: 10, marginTop: 10 }}
                      >
                        <Button
                          color="warning"
                          variant="contained"
                          style={{ height: "25px" }}
                          onClick={handleClosexoa}
                        >
                          Hủy
                        </Button>
                      </FormControl>
                    </GridItem>
                  </CardBody>
                </Card>
              </GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
            </GridContainer>
          </div>
        </Modal>
      </GridItem>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="info"
            icon={AddAlert}
            message="Xóa thành công"
            open={alert}
            closeNotification={() => setAlert(false)}
            close
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="info"
            icon={AddAlert}
            message="Import dữ liệu thành công"
            open={alert1}
            closeNotification={() => setAlert1(false)}
            close
          />
        </GridItem>
      </GridContainer>
    </GridContainer>
  );
}
